import { render } from "./CalculatorDialog.vue?vue&type=template&id=afa5559c"
import script from "./CalculatorDialog.vue?vue&type=script&lang=js"
export * from "./CalculatorDialog.vue?vue&type=script&lang=js"

import "./CalculatorDialog.vue?vue&type=style&index=0&id=afa5559c&lang=scss"
script.render = render

export default script